<template>
  <el-autocomplete
    v-model="positionValue"
    placeholder="请输入地点"
    value-key='name'
    @select="selectPosition"
    @blur="blur"
    :trigger-on-focus="false"
    :fetch-suggestions="debounceGetSelect"
  />
  <!-- </el-autocomplete> -->
  <!-- <el-select
    filterable
    remote
    :remote-method="debounceGetSelect"
    v-model="positionValue"
    @change="selectPosition"
  >
    <el-option
    v-for="item in positionList"
    :key="item.location"
    :label="item.name"
    :value="item.location"/>
  </el-select> -->
</template>

<script>
import { POI } from '@/utils/AmapApi'
export default {
  data () {
    return {
      // positionList: [],
      positionValue: '',
      positionLocation: '',
      debounceTimeout: null
    }
  },
  props: {
    type: {
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    lon: {
      type: String,
      default: ''
    },
    lat: {
      type: String,
      default: ''
    }
  },
  methods: {
    debounceGetSelect (value, cb) {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        if (!value) {
          return cb()
        }
        POI({ keywords: value }).then(res => {
          // this.positionList = [].concat(res)
          cb(res)
        })
      }, 500)
    },
    selectPosition (value) {
      this.positionLocation = value.location
      this.$emit('change', value, this.type)
    },
    blur () {
      // 当前无选中坐标 清空输入
      if (!this.positionLocation) {
        this.positionValue = ''
      }
      // 当前输入被清空 是否需要删除
      if (!this.positionValue) {
        this.positionLocation = ''
        this.$emit('change', undefined, this.type)
      }
      // 当前输入与实际不符
      if (this.value !== this.positionValue) {
        this.positionValue = this.value
      }
    }
  },
  watch: {
    value () {
      if (this.value === this.positionValue) return
      this.positionValue = this.value
    },
    lon () {
      if (!this.lon) return
      this.positionLocation = `${this.lon},${this.lat}`
    }
  }
}
</script>
